/* ============================================================
   nx-pdp — PDP挙動(2026-07-15)
   ③ 定期選択時に価格横へ「定期便初回15%OFF」バッジ表示
      (定期購買アプリはプラン選択時に form へ hidden input[name="selling_plan"]
       を挿入し、1回決済へ戻すと除去する — 実機で確認済みのシグナル)
   ⑧ 説明文内の旧メールアドレスを info@ へ置換
   ⑪ 説明文内「定期購入について」ブロックをDawn準拠のアコーディオンに折りたたみ
   ============================================================ */
(function () {
  'use strict';

  /* ---- ⑧⑪ 説明文の後処理 ---- */
  document.querySelectorAll('.product__description').forEach(function (desc) {
    if (desc.dataset.nxProcessed) return;
    desc.dataset.nxProcessed = '1';

    if (desc.innerHTML.indexOf('support@naturism-diet.com') !== -1) {
      desc.innerHTML = desc.innerHTML.split('support@naturism-diet.com').join('info@naturism-diet.com');
    }

    /* 説明はラッパーdivに包まれていることがあるため、任意の深さから
       「定期購入について」だけを内容とする見出し要素を探す */
    var marker = null;
    var all = desc.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].children.length <= 1 && all[i].textContent.trim() === '定期購入について') {
        marker = all[i];
      }
    }
    if (!marker) return;
    while (marker.parentElement !== desc && marker.parentElement.textContent.trim() === '定期購入について') {
      marker = marker.parentElement;
    }
    var parent = marker.parentElement;
    var kids = Array.prototype.slice.call(parent.children);
    var idx = kids.indexOf(marker);
    if (idx === -1) return;

    var outer = document.createElement('div');
    outer.className = 'product__accordion accordion quick-add-hidden nx-desc-fold-wrap';
    var det = document.createElement('details');
    var sum = document.createElement('summary');
    var st = document.createElement('div');
    st.className = 'summary__title';
    /* アイコンはサブスク=配送を示すトラック(配送・送料タブのicon-accordionを流用)。
       ※summary直下のsvg=キャレット、.summary__title内のsvg=アイコン。
       以前は前者の区別なく最初のsvgを複製し巨大な葉が出ていた(2026-07-15修正) */
    var truck = null;
    document.querySelectorAll('.product__accordion details').forEach(function (dd) {
      if (!truck && dd.textContent.indexOf('配送・送料') !== -1) {
        var tsvg = dd.querySelector('.summary__title svg');
        if (tsvg) truck = tsvg.cloneNode(true);
      }
    });
    if (truck) st.appendChild(truck);
    var h = document.createElement('h2');
    h.className = 'h4 accordion__title';
    h.textContent = '定期購入について';
    st.appendChild(h);
    sum.appendChild(st);
    var caret = document.querySelector('.product__accordion summary > svg');
    if (caret) sum.appendChild(caret.cloneNode(true));
    det.appendChild(sum);
    var content = document.createElement('div');
    content.className = 'accordion__content rte';
    kids.slice(idx + 1).forEach(function (el) {
      content.appendChild(el);
    });
    det.appendChild(content);
    outer.appendChild(det);
    marker.replaceWith(outer);
  });

  /* ---- ③ 定期バッジ切替 ---- */
  var updateBadge = function () {
    var on = Array.prototype.some.call(document.querySelectorAll('form [name="selling_plan"]'), function (e) {
      return !!e.value;
    });
    document.querySelectorAll('.nx-price-subbadge').forEach(function (b) {
      b.hidden = !on;
    });
  };
  updateBadge();
  /* 初期表示は上で反映済み。以降の追従はMutationObserver対応環境のみ(防御的) */
  if (window.MutationObserver) {
    var root = document.querySelector('product-info') || document.body;
    new MutationObserver(updateBadge).observe(root, { subtree: true, childList: true });
  }
  document.addEventListener('change', updateBadge, true);
})();
